module.exports = __webpack_public_path__ + "img/recommed-img3.438ddb34.jpg";